export default "__VITE_ASSET__CirGqphk__"